// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible'
import '@/common/styles/reset.css'
import "swiper/css/swiper.css";
import store from './store'
import MintUI from 'mint-ui'
import { judgePC } from '@/utils/util'

const isPc = judgePC()
if (isPc) {//自定义的判断是pc还是移动端的方法
  import('@/common/styles/pc.css')
}
if (!isPc) {
  import('@/common/styles/mb.css')
}

Vue.use(MintUI)

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js